<div class="dashboard-card" *transloco="let t">
  <img
    class="dashboard-card__header"
    ngSrc="assets/images/htx-dashboard-card-bg.jpeg"
    alt="{{ t('dashboard.systems.' + systemKey() + '.title') }}"
    height="136"
    width="368"
  />

  <span class="dashboard-card__title">{{ t('dashboard.systems.' + systemKey() + '.title') }}</span>

  <div class="dashboard-card__content">
    <p class="dashboard-card__description">
      {{ t('dashboard.systems.' + systemKey() + '.description') }}
    </p>

    <div class="dashboard-card__status">
      <span>{{ t('dashboard.card.status.label') }}</span>
      <htx-status-indicator [status]="healthStatus()"></htx-status-indicator>
    </div>
  </div>
</div>
